<div class="prs-fabs" [class.prs-fabs--visible]="visible">
  <button
    type="button"
    class="prs-fab prs-fab--secondary"
    (click)="scrollTop()"
    [attr.aria-label]="'shell.scroll_top' | translate"
  >
    <svg class="prs-fab__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path
        d="M12 5v14M5 12l7-7 7 7"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </button>
</div>
